import React from 'react'
import styled from './Rating.module.css' 
import FullStar from '../img/icon/ic_star_fill.png'
import BlankStar from '../img/icon/ic_star_blank.png'
const Rating = ({ value }:any) => {
  const fullStars = Math.floor(value)
  const halfStar = value % 1 !== 0
  const emptyStars = 5 - fullStars - (halfStar ? 1 : 0)

  return (
    <div className={styled.rating}>
      {[...Array(fullStars)].map((_, index) => 
        (<img src={FullStar} key={index} className={`${styled.star}`}/>))}
      {halfStar && <img src={BlankStar} className={`${styled.star} ${styled.half}`}/>}
      {[...Array(emptyStars)].map((_, index) => 
        (<span key={index} className={`${styled.star} ${styled.empty}`}/>))}
    </div>
  )
}

export default Rating